import React from "react";

const AccountOverview = ({
  width = 40,
  height = 40,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="4" fill="#F6F8FA" />
      <path
        d="M16.5421 23.4034C15.5007 22.669 14.7202 21.6221 14.3136 20.4144C13.907 19.2067 13.8955 17.9009 14.2807 16.6862C14.6659 15.4715 15.4279 14.411 16.4562 13.6584C17.4845 12.9057 18.7257 12.5 20 12.5C21.2743 12.5 22.5155 12.9057 23.5438 13.6584C24.5721 14.411 25.3341 15.4715 25.7193 16.6862C26.1045 17.9009 26.093 19.2067 25.6864 20.4144C25.2798 21.6221 24.4993 22.669 23.4579 23.4034L25.0201 26.9734C25.0452 27.0305 25.0556 27.093 25.0505 27.1552C25.0453 27.2174 25.0247 27.2773 24.9905 27.3296C24.9563 27.3818 24.9096 27.4246 24.8547 27.4542C24.7997 27.4838 24.7383 27.4993 24.6759 27.4991H15.3234C15.2611 27.4992 15.1997 27.4838 15.1449 27.4542C15.09 27.4246 15.0434 27.3819 15.0092 27.3298C14.9751 27.2776 14.9544 27.2178 14.9492 27.1558C14.9439 27.0937 14.9542 27.0312 14.9791 26.9741L16.5414 23.4034H16.5421ZM21.5934 22.8836L22.5924 22.1779C23.3737 21.6272 23.9593 20.8421 24.2645 19.9363C24.5697 19.0305 24.5785 18.051 24.2896 17.1399C24.0008 16.2287 23.4294 15.4332 22.6581 14.8686C21.8868 14.304 20.9558 13.9996 20 13.9996C19.0442 13.9996 18.1132 14.304 17.3419 14.8686C16.5706 15.4332 15.9992 16.2287 15.7104 17.1399C15.4215 18.051 15.4303 19.0305 15.7355 19.9363C16.0407 20.8421 16.6263 21.6272 17.4076 22.1779L18.4059 22.8836L17.0431 25.9991H22.9561L21.5934 22.8836ZM17.0889 19.2266L18.5439 18.8629C18.6246 19.1879 18.8118 19.4766 19.0756 19.6829C19.3395 19.8891 19.6647 20.0012 19.9996 20.0012C20.3345 20.0012 20.6598 19.8891 20.9236 19.6829C21.1874 19.4766 21.3746 19.1879 21.4554 18.8629L22.9104 19.2266C22.7472 19.875 22.3722 20.4503 21.8449 20.8614C21.3177 21.2724 20.6682 21.4956 19.9996 21.4956C19.331 21.4956 18.6816 21.2724 18.1543 20.8614C17.627 20.4503 17.252 19.875 17.0889 19.2266Z"
        fill="#868C98"
      />
    </svg>
  );
};

export default AccountOverview;
